// Mounts the platform-provided user-detail route at /admin/users/$id.

import { userDetailRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/users/$id')({
  ...userDetailRoute,
  staticData: {
    breadcrumb: 'User',
  },
})
